function displayPassword(inputId: string) {
  const input = document.getElementById(inputId);

  if (!input || !(input instanceof HTMLInputElement)) {
    return false;
  }

  // Global window.event? Would be nicer to do with react
  event.preventDefault();
  event.stopPropagation();
  input.type === "text" ? "password" : "text";
  input.focus();
  return true;
}

export default displayPassword;
